import { showErrorBar } from 'actions/errorBar';
import { ERROR } from 'constants/error-severities';
import { OAUTH_BUTTON_CLICKED } from 'constants/events';
import { ANON_RECORD_A_REPLY } from 'constants/onboarding';
import { LOOM_URI } from 'constants/routes';
import * as analytics from 'utilities/analytics';
import { createVideoComment } from 'utilities/comments';
import * as logger from 'utilities/loggerx';
import { incrementMetric } from 'utilities/metrics';
import {
  createAnonRecordingCache,
  updateAnonRecordingOwnership,
} from 'utilities/shareVideo';
import { store } from 'utilities/store';
import { getUserChecklist } from 'utilities/user';

import { MAP_SCREEN_KEY_TO_COMPONENT } from './constants';

export const getComponentFromKey = key => {
  return MAP_SCREEN_KEY_TO_COMPONENT[key];
};

export const afterOauthLogin = async ({
  videoId: recordedReplyVideoId,
  addReplyId,
  videoCurrentTime,
  repliedToVideoId,
  provider,
}) => {
  const { data } = await getUserChecklist();
  const redirectUrl = new URL(window.location.href);

  const cacheArgs = {
    replyVideoId: recordedReplyVideoId,
    repliedToVideoId,
    videoCurrentTime,
    addReplyId,
  };

  // create video and user link in redis\
  try {
    await createAnonRecordingCache(cacheArgs);
  } catch (err) {
    store.dispatch(showErrorBar(ERROR, `There was an error.`));
    logger.error(
      err,
      'Failed to create a Redis link for anonymous record a reply '
    );
  }

  if (videoCurrentTime) {
    redirectUrl.searchParams.append('videoCurrentTime', videoCurrentTime);
  }

  if (data.me.checklist.complete_onboarding) {
    // signing in, post video
    postRecordReplyComment({
      recordedReplyVideoId,
      addReplyId,
      videoCurrentTime,
    });

    analytics.track(OAUTH_BUTTON_CLICKED, {
      provider,
      isSignUp: false,
      source: ANON_RECORD_A_REPLY,
    });

    incrementMetric('button.click', {
      context: OAUTH_BUTTON_CLICKED,
      provider,
      isSignUp: false,
      source: ANON_RECORD_A_REPLY,
    });

    try {
      await updateAnonRecordingOwnership();
    } catch (err) {
      store.dispatch(showErrorBar(ERROR, `There was an error.`));
      logger.error(
        err,
        'Failed to transfer video ownership for anonymous record a reply'
      );
    }
  } else {
    // signing up
    redirectUrl.searchParams.append('replyVideoId', recordedReplyVideoId);

    if (addReplyId) {
      redirectUrl.searchParams.append('addReplyId', addReplyId);
    }

    analytics.track(OAUTH_BUTTON_CLICKED, {
      provider,
      isSignUp: true,
      source: ANON_RECORD_A_REPLY,
    });

    incrementMetric('button.click', {
      context: OAUTH_BUTTON_CLICKED,
      provider,
      isSignUp: true,
      source: ANON_RECORD_A_REPLY,
    });
  }

  window.location.href = redirectUrl.href;
};

export const postRecordReplyComment = async ({
  recordedReplyVideoId,
  addReplyId,
  videoCurrentTime,
}) => {
  const state = store.getState();

  const comment = `${LOOM_URI}/share/${recordedReplyVideoId}`;
  const videoPassword = state.video_player.password;
  const videoId = state.video_player.video.id;

  try {
    await createVideoComment({
      anonUserName: null,
      comment,
      parentPostId: addReplyId,
      password: videoPassword,
      timestamp: parseInt(videoCurrentTime),
      videoId,
    });
  } catch (err) {
    store.dispatch(showErrorBar(ERROR, `Unable to create comment`));
    logger.error(
      err,
      'Failed to create a comment for anonymous record a reply'
    );
  }
};
